module.exports = __webpack_public_path__ + "img/bar.e8e58514.svg";